// extracted by mini-css-extract-plugin
export default {"root":"root__index__eOBnt","invert":"invert__index__BdvcE"};